import {
  RP_AVERAGE_GAS_MODEL_LIST,
  RP_AVERAGE_GAS_PAGINATION,
  RP_AVERAGE_GAS_SEARCH,
  RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR
} from "./actionType";



import moment from 'moment';


const initialState = {
  modelDeviceList: [],
  modelSearch: { DELIVERYFUEL_YEARS: new Date().getFullYear() },
  dropDownSearchYear: {
    label: new Date().getFullYear(),
    value: new Date().getFullYear()
  },
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RP_AVERAGE_GAS_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case RP_AVERAGE_GAS_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case RP_AVERAGE_GAS_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR:
      return {
        ...state,
        dropDownSearchYear: action.payload,
      }
    default:
      return state;
  }
};
